// src/settingComponent/apiSetting/ApiPopupDelete.jsx
import React, { useState } from 'react';
import './ApiPopupDelete.css';
import { getFunctions, httpsCallable } from 'firebase/functions';

const ApiPopupDelete = ({ keyData, onClose, onDelete }) => {
  const [isLoading, setIsLoading] = useState(false);
  const functions = getFunctions();
  const modifyKeyAPICallable = httpsCallable(functions, 'modifyKeyAPI');

  const maskKey = key => {
    const head = key.slice(0, 4);
    const tail = key.slice(-4);
    return `${head}…${tail}`;
  };

  const handleRevoke = async () => {
    setIsLoading(true);
    const payload = {
      keyName: keyData.apiKeyName || '',
      productsList: keyData.apiKeyProductsList || [],
      apiKey: keyData.apiKey,
      isDelete: true,
    };
    // console.log('modifyKeyAPI payload:', payload);
    try {
      await modifyKeyAPICallable(payload);
      onDelete();
    } catch (err) {
      // console.error('Error calling modifyKeyAPI:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="api-popup-overlay">
      <div className="api-popup-modal">
        <div className="api-popup-header">
          <h2>Revoke secret key</h2>
          <button className="api-popup-close" onClick={onClose}>&times;</button>
        </div>
        <div className="api-popup-body">
          <p className="delete-description">
            This API key will immediately be disabled. API requests made using this key will be rejected, which could cause any systems still depending on it to break. Once revoked, you'll no longer be able to view or modify this API key.
          </p>
          <div className="delete-input-wrapper">
            <input
              type="text"
              className="delete-key-input"
              value={maskKey(keyData.apiKey)}
              disabled
            />
          </div>
        </div>
        <div className="api-popup-footer">
          <button
            className="api-cancel-button"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="api-delete-button"
            onClick={handleRevoke}
            disabled={isLoading}
          >
            {isLoading ? 'Revoking…' : 'Revoke key'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiPopupDelete;
